import { toEmbedUrl } from "@/lib/video";
import { ExternalLink, PlayCircle, Radio, Video } from "lucide-react";

const iframeAllow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

function Frame({ url, title, testid }) {
  const embed = toEmbedUrl(url);
  if (embed === url) {
    return (
      <a href={url} target="_blank" rel="noreferrer" data-testid={`${testid}-link`} className="eyw-btn w-full justify-center">
        <ExternalLink size={15} /> Open the {title.toLowerCase()}
      </a>
    );
  }
  return (
    <div className="aspect-video rounded-2xl overflow-hidden bg-black" data-testid={`${testid}-embed`}>
      <iframe src={embed} title={title} className="w-full h-full" allow={iframeAllow} allowFullScreen />
    </div>
  );
}

export const StreamPlayer = ({ s }) => {
  if (s.status === "ended") {
    if (s.replay_url) return <Frame url={s.replay_url} title="Replay" testid="watch-replay" />;
    return (
      <div className="aspect-video rounded-2xl bg-[#1A242B] text-white/80 grid place-items-center text-center px-6" data-testid="watch-ended">
        <div><PlayCircle className="mx-auto mb-3" size={34} /><p>This stream has ended.{s.replay_available === false ? " No replay is available." : ""}</p></div>
      </div>
    );
  }
  if (s.join_url) {
    return (
      <div className="aspect-video rounded-2xl bg-[#144F75] text-white grid place-items-center text-center px-6" data-testid="watch-zoom">
        <div>
          <Video className="mx-auto mb-3" size={34} />
          <p className="font-serif text-2xl mb-4">This session runs on Zoom.</p>
          <a href={s.join_url} target="_blank" rel="noreferrer" data-testid="watch-zoom-join" className="eyw-btn !bg-white !text-[#144F75]">Join on Zoom</a>
        </div>
      </div>
    );
  }
  if (s.watch_url) return <Frame url={s.watch_url} title="Live stream" testid="watch-live" />;
  return (
    <div className="aspect-video rounded-2xl bg-[#1A242B] text-white/80 grid place-items-center text-center px-6" data-testid="watch-not-ready">
      <div><Radio className="mx-auto mb-3" size={34} /><p>The host hasn't connected the stream yet. Check back closer to the start time.</p></div>
    </div>
  );
};
